export default "__VITE_ASSET__DDZJJbiU__"